import React from 'react';
import styles from './FullPageHr.module.scss';

const FullPageHr = () => <hr className={styles.root} />;

export { FullPageHr };
